/* app/js/src/components/batch-import/edit-rule.scss */
.cursor-pointer {
  cursor: pointer;
}
.input-group input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.input-group input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input.ng-invalid.ng-dirty[type=text],
.input-group input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn:focus {
  outline-color: #ffffff;
}
.btn:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.input-group input[type=checkbox] {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  margin-right: 13px;
  cursor: pointer;
  position: relative;
}
.input-group input[type=checkbox]:before {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  content: "";
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: -25%;
}
.input-group input[type=checkbox]:checked:before {
  content: "\f00c";
  font-family: "FontAwesome";
  color: #232f3a;
}
.input-group input[type=checkbox]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
  margin-bottom: 10px;
}
.input-group label {
  display: inline-block;
  margin-right: 13px;
  color: #7d8fa1;
}
.input-group input[type=text] {
  width: 305px;
  border-radius: 4px;
  vertical-align: middle;
}
.input-group:not(:last-child) {
  margin-bottom: 30px;
}
.input-group > * {
  vertical-align: middle;
}
.tasks .task {
  font-style: italic;
  letter-spacing: 0.1px;
  color: #232f3a;
  font-size: 12px;
}
.tasks .task-content {
  font-style: normal;
  margin-top: 14px;
}
:host {
  display: flex;
  flex-direction: column;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  position: relative;
  width: 1030px;
}
.x-sign {
  position: absolute;
  right: 10.5px;
  top: 10.5px;
  width: 21px;
  height: 21px;
  text-align: center;
  padding-top: 4px;
  cursor: pointer;
}
.add-edit-header {
  margin-bottom: 10px;
}
.select-rule-type-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.name-input {
  width: 200px;
}
.rule-input {
  width: 300px;
}
.options-container {
  margin-top: 25px;
}
.options-container > .options {
  display: flex;
}
.options-container > .options > .options-control {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.options-container > .options > .options-control label {
  margin-right: 15px;
  cursor: pointer;
}
.icn-radio-button {
  background-color: white;
  display: flex;
}
.icn-radio-button .radio-separator {
  height: 7px;
}
.icn-radio-button input + label {
  margin-right: 20px;
  cursor: pointer;
}
input[type=range] {
  -webkit-appearance: none;
  width: 150px;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  background: #e3e6ea;
  opacity: 0.8;
  border-radius: 1px;
  border: 0px solid #000000;
  margin: 0px 10px 0px 10px;
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #c9cdd6;
  height: 14px;
  width: 14px;
  border-radius: 25px;
  background: #7d8fa1;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;
}
icn-dropdown {
  margin: 0 7px 0 7px;
  width: 200px;
}
.icn-label {
  color: #879baf;
  font-size: 12px;
  font-family: "Open Sans";
}
.input-range-container {
  width: 150px;
  position: relative;
}
.offset-label {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translate(-50%, 0);
}
footer {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}
.btn {
  width: 72px;
}
/*# sourceMappingURL=edit-rule.css.map */
